const discoveryDayConfig = {
  starts: '2027-03-06T09:00:00-07:00', // 9:00 AM MST on Saturday of RootsTech weekend
  ends: '2027-03-06T15:00:00-07:00', // 3:00 PM MST on Saturday of RootsTech weekend
}

export default discoveryDayConfig
